/*
*   Возвращает сгенерированную строку, которая является url ссылкой с подставленными динамическими параметрами.
*   Используется для динамических маршрутов. Хотелось по максимум все URL во всем приложении хранить в routes/routes.tsx файле.
*   Без этой функции - в каждом динамическом маршруте пришлось бы писать, например: `/plan/${planId}/version/${planVersionId}/plan-summary`
*   С этой функцией  - в параметр url отдаем нужный маршрут из файла routes.tsx, во второй параметр отдаем массив объектов с ключом и значением параметра.
*
*   Входные данные:
*       url    - [обязательный] - ссылка-шаблон, значение одной из констант в файле routes/routes.tsx.
*       params - [обязательный] - массив объектов с параметрами:
*            [{ 
*                   key:   - [обязательный] - название параметра (пример: 'planId') 
*                   value: - [обязательный] - значение параметра параметра (пример: 9)  
*            }]
*
*   Пример: 
*       Входящие параметры
*            url    = '/plan/:planId/version/:planVersionId'
*            params = [
*                {key: 'planId', value: '9'}
*                {key: 'planVersionId', value: '15'}
*            ]
*        Выходящее значение
*            '/plan/9/version/15/plan-summary'
*
*/

export function getGeneratedDynamicLink(url: string, params: { key: string, value: any }[]): string {

    let generateLink: string = '';
    let comparePathnameURL = url.split('/');

    for (let i = 0; i < comparePathnameURL.length; i++) {
        if (comparePathnameURL[i].startsWith(':')) {
            if (comparePathnameURL[i].endsWith('?')) {
                const optionalParameter = params.find(p => comparePathnameURL[i].replace('?', '') === (':' + p.key))?.value;
                if (optionalParameter) {
                    generateLink += optionalParameter;
                }
            }
            else {
                generateLink += params.find(p => comparePathnameURL[i] === (':' + p.key))?.value;
            }
            if (i < comparePathnameURL.length - 1) generateLink += '/';
        }
        else {
            generateLink += comparePathnameURL[i];
            if (i < comparePathnameURL.length - 1) generateLink += '/';
        }
    }

    return generateLink.replace('//', '/');
}

export const getDynamicLink = <T extends object>(path: string, params: T) => getGeneratedDynamicLink(
    path, Object.keys(params).map((key) => ({ key, value: params[key] })));
